<template>
  <main class="password-gate">
    <section class="password-gate__card workspace-card" aria-labelledby="verify-title">
      <h1 id="verify-title">Verify your email</h1>
      <p>Sign in to the assigned account, then confirm. Opening this page alone does not bind an email.</p>
      <p v-if="!token && !done" class="ui-notice">Please reopen the original link in your email.</p>
      <form v-if="token && !auth.isAuthenticated" @submit.prevent="signIn">
        <label>Username<input v-model="username" class="ui-input" autocomplete="username" required /></label>
        <label>Password<input v-model="password" class="ui-input" type="password" autocomplete="current-password" required /></label>
        <button class="btn-primary" :disabled="busy" type="submit">Sign in</button>
      </form>
      <div v-if="auth.isAuthenticated && token && !done">
        <p>Signed in as <strong>{{ auth.user.username }}</strong>. Make sure this is the account the email belongs to.</p>
        <button class="btn-primary" :disabled="busy" type="button" @click="confirm">Confirm email</button>
        <button class="ui-button" :disabled="busy" type="button" @click="switchAccount">Switch account</button>
      </div>
      <p v-if="message" class="ui-notice" role="status">{{ message }}</p>
      <p><router-link to="/login">Back to login / ask for help</router-link></p>
    </section>
  </main>
</template>
<script setup>
import { ref } from 'vue'
import { useAuthStore } from '../stores/auth'
import { takeEmailToken, accountRequest } from '../account-email-client'
const auth = useAuthStore()
const token = ref(takeEmailToken()), username = ref(''), password = ref(''), message = ref(''), busy = ref(false), done = ref(false)
async function signIn() {
  busy.value = true; message.value = ''
  try { await auth.login(username.value.trim(), password.value, '') }
  catch (error) { message.value = error.message }
  finally { busy.value = false; password.value = '' }
}
async function confirm() {
  busy.value = true; message.value = ''
  try { await accountRequest('auth/email/verify', { token: token.value }); token.value = ''; done.value = true; message.value = 'Email verified.' }
  catch (error) { message.value = error.message }
  finally { busy.value = false }
}
async function switchAccount() {
  busy.value = true
  try { await auth.logout(); message.value = 'Sign in to the account this email belongs to.' }
  catch { message.value = 'Could not sign out. Please try again.' }
  finally { busy.value = false }
}
</script>
